import Vue from 'vue';


var websock = null
var globalCallback = null
var params = null
//    初始化websocket
/**
 * CONNECTING：值为0，表示正在连接。
OPEN：值为1，表示连接成功，可以通信了。
CLOSING：值为2，表示连接正在关闭。
CLOSED：值为3，表示连接已经关闭，或者打开连接失败。
 */
function initWebSocket () {
  websock = new WebSocket("/api/websocket");
  websock.onmessage = function (e) {
    websocketonmessage(e)
  }

  websock.onclose = function (e) {
    websocketclose(e)
  }

  websock.onopen = function () {
    websocketOpen()
  }

  websock.onerror = function () {
    // console.log('WebSocket连接发生错误')
  }
}

// 实际调用方法
const sendSock = function (agentData, callback, param) {
  globalCallback = callback
  params = param
  if(websock.readyState === 1) {
    // 若是ws开启状态
    websocketsend(agentData)
  } else if (websock.readyState === 0) {
    // 若是正在开启状态， 则等待1s重新调用
    setTimeout(function () {
      sendSock(agentData, callback)
    }, 1000)
  } else {
    setTimeout(function () {
      sendSock(agentData, callback)
    }, 1000)
  }
}


// 数据接收
function websocketonmessage (e) {
  globalCallback(params)
}

// 数据发送
function websocketsend (agentData) {
  websock.send(agentData)
}

// 关闭
function websocketclose (e) {
  // console.log('connection closed:o%', e)
}

// 创建 websocket 连接
function websocketOpen (e) {
  // console.log('连接成功')
}

initWebSocket()


const socketPlugin = {}
socketPlugin.install = function (Vue, options) {
  Object.defineProperties(Vue.prototype, {
    $sockApi: {
      get() {
        return sendSock;
      },
    },
  });
}

Vue.use(socketPlugin)
